export const ntnCd = [
    { code: '', name: '선택' },
    { code: '082', name: '대한민국' },
]
